import addFlight from './src/got-flight';

export default addFlight;



// WEBPACK FOOTER //
// ./shared/lib/flick/index.js